<!-- Not found state -->
<div class="confirm-shell" *ngIf="notFound">
  <div class="confirm-card animate-scale-in">
    <div class="confirm-icon confirm-icon--error">
      <span class="material-symbols-outlined">error</span>
    </div>
    <h2>Turno no encontrado</h2>
    <p>No pudimos encontrar el turno solicitado.</p>
    <button class="btn-primary" (click)="goBooking()">Volver a reservar</button>
  </div>
</div>

<!-- Confirmation state -->
<div class="confirm-shell animate-fade-in" *ngIf="!notFound && appointment">
  <div class="confirm-card animate-scale-in">

    <div class="confirm-icon confirm-icon--success">
      <span class="material-symbols-outlined">check_circle</span>
    </div>

    <div class="confirm-header">
      <h1>�Turno reservado!</h1>
      <p>Tu turno fue registrado exitosamente. Recibir�s una confirmaci�n cuando el profesional lo apruebe.</p>
    </div>

    <div class="confirm-details">
      <div class="confirm-row">
        <span class="material-symbols-outlined">person</span>
        <div>
          <span class="confirm-label">Profesional</span>
          <span class="confirm-value">{{ appointment!.professionalName }}</span>
        </div>
      </div>
      <div class="confirm-row">
        <span class="material-symbols-outlined">event</span>
        <div>
          <span class="confirm-label">Fecha</span>
          <span class="confirm-value">{{ formatDateFull(appointment!.date) }}</span>
        </div>
      </div>
      <div class="confirm-row">
        <span class="material-symbols-outlined">schedule</span>
        <div>
          <span class="confirm-label">Hora</span>
          <span class="confirm-value">{{ appointment!.time }} hs</span>
        </div>
      </div>
      <div class="confirm-row">
        <span class="material-symbols-outlined">medical_services</span>
        <div>
          <span class="confirm-label">Servicio</span>
          <span class="confirm-value">{{ appointment!.serviceType }}</span>
        </div>
      </div>
      <div class="confirm-row" *ngIf="appointment!.notes">
        <span class="material-symbols-outlined">edit_note</span>
        <div>
          <span class="confirm-label">Notas</span>
          <span class="confirm-value">{{ appointment!.notes }}</span>
        </div>
      </div>
    </div>

    <div class="confirm-status">
      <span class="status-chip status-chip--pending" *ngIf="appointment!.status === 'pending'">
        <span class="material-symbols-outlined">hourglass_top</span>
        Pendiente de confirmaci�n
      </span>
      <span class="status-chip status-chip--confirmed" *ngIf="appointment!.status === 'confirmed'">
        <span class="material-symbols-outlined">verified</span>
        Confirmado
      </span>
    </div>

    <div class="calendar-actions">
      <h3>Agregar al calendario</h3>
      <div class="calendar-btns">
        <button class="cal-btn" (click)="downloadIcs()">
          <span class="material-symbols-outlined">download</span>
          Descargar .ics
        </button>
        <button class="cal-btn cal-btn--google" (click)="openGoogle()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          Google Calendar
        </button>
      </div>
    </div>

    <button class="btn-primary confirm-back" (click)="goBooking()">
      <span class="material-symbols-outlined">add</span>
      Reservar otro turno
    </button>

  </div>
</div>
